/**
 * Responsibility: Register hosted dialog content for the generic modal shell.
 * Scope: Lookup only; no dialog state, lifecycle, or domain behavior.
 */
import AboutDialog from './about-dialog.riot'
import AbilityArgsDialog from './ability-args-dialog.riot'
import TalkDialog from './talk-dialog.riot'
import HowToPlayDialog from './how-to-play-dialog.riot'
import TradeDialog from './trade-dialog.riot'
import CompanionChatDialog from './companion-chat-dialog.riot'
import CompanionSheetDialog from './companion-sheet-dialog.riot'
import AtlasDialog from './atlas-dialog.riot'
import InfoDialog from './info-dialog.riot'
import LocationDialog from './location-dialog.riot'
import NotebookDialog from './notebook-dialog.riot'
import NpcSheetDialog from './npc-sheet-dialog.riot'
import SettingsDialog from './settings-dialog.riot'
import SystemControlsDialog from './system-controls-dialog.riot'
import PlayerProfileSheet from '../player-profile-sheet.riot'

export const dialogComponents = {
  'about-dialog': AboutDialog,
  'ability-args-dialog': AbilityArgsDialog,
  'talk-dialog': TalkDialog,
  'how-to-play-dialog': HowToPlayDialog,
  'trade-dialog': TradeDialog,
  'chat-dialog': CompanionChatDialog,
  'companion-sheet-dialog': CompanionSheetDialog,
  'atlas-dialog': AtlasDialog,
  'info-dialog': InfoDialog,
  'location-dialog': LocationDialog,
  'notebook-dialog': NotebookDialog,
  'npc-sheet-dialog': NpcSheetDialog,
  'settings-dialog': SettingsDialog,
  'system-controls-dialog': SystemControlsDialog,
  'player-profile-sheet': PlayerProfileSheet,
}

export type DialogComponentId = keyof typeof dialogComponents

export function resolveDialogComponent(id: string) {
  return id in dialogComponents ? id as DialogComponentId : null
}
